import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ViewTimesheetPDF from './ViewTimesheetPDF';
import ViewTimecardPDF from './ViewTimecardPDF';
import ApprovalTimesheetExcel from './ApprovalTimesheetExcel';
import ApprovalTimecardExcel from './ApprovalTimecardExcel';

const ExportOptions = ({ timesheetDetails, viewTab }) => (
  <div className="d-flex justify-content-end align-items-center export-options">
    <small>Download as </small>
    <Button
      variant="white"
      size="sm"
      className="mx-1"
      onClick={() =>
        viewTab === 'timeCard'
          ? ViewTimecardPDF(timesheetDetails)
          : ViewTimesheetPDF(timesheetDetails)
      }
    >
      PDF
    </Button>
    <Button
      variant="white"
      size="sm"
      className="ms-1"
      onClick={() =>
        viewTab === 'timeCard'
          ? ApprovalTimecardExcel(timesheetDetails)
          : ApprovalTimesheetExcel(timesheetDetails)
      }
    >
      Excel
    </Button>
  </div>
);

ExportOptions.propTypes = {
  timesheetDetails: PropTypes.array,
  viewTab: PropTypes.string,
};

export default ExportOptions;
